const setSpouseCountry = (id = null, val = null) => {
  return {
    type: 'SET_SPOUSECOUNTRY',
    id,
    data: val,
  }
}

export default {
  setSpouseCountry,
}